/** @format */

import { AttributeOption } from '@pdp/data-access/interfaces';
import { PersonalizationState } from '@shared/data-access/interfaces';

export interface AttributeErrorResponse {
  attributes: AttributeOption[][];
  isErrorsOnAttributes: boolean;
  personalizedAttributes: PersonalizationState[] | Record<string, never>[];
}
